import { Box, Grid, IconButton, ListItemButton, ListItemIcon, Modal, ListItemText, Tooltip, Paper, Typography, useMediaQuery, Button, Menu, MenuItem, Popover, Badge } from '@mui/material';
import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { ReactChildren } from '../../interfaces/Common';
import KenLoader from '../../GlobalComponents/KenLoader';
import { getUserDetails } from '../../storageService';
import { getStudentInfo } from '../../Utils/apiService';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import DefaultStudentImage from '../../Assets/student-profile.jpg';
import DefaultFacultyImage from '../../Assets/faculty-profile.jpg';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import MobileNavTabs from './MobileTabs';
import NotificationModal from './NoficationModal';
import CalendarIcon from '../../Assets/icons_calendar.svg';
import NotificationIcon from '../../Assets/icons_notification.svg';
import SettingIcon from '../../Assets/icons_settings.svg';
import DefaultProfileImage from '../../Assets/image1.png'
import { getUnreadNotificationCount } from '../../Utils/apiService';
// import { getBasicProfileSetting } from '../../Utils/apiService';
import mixpanel from 'mixpanel-browser';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  console.log("User from AuthContext:", user);
  const userData: any = user as AuthUser;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openNotification, setOpenNotification] = useState(false);
  const [activeIconIndex, setActiveIconIndex] = useState<number | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [notificationCount, setNotificationCount] = useState<number>(0);

  // Get user details from localStorage
  const userDetails = getUserDetails();

  const fetchNotificationCount = useCallback(async () => {
    try {
      const userid = userDetails?.ContactId;
      if (userid) {
        const count = await getUnreadNotificationCount(userid);
        console.log('Notification count:', count);
        setNotificationCount(Math.max(0, count));
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
      setNotificationCount(0);
    }
  }, [userDetails?.ContactId]);

  const handleClickIcon = (index: number) => {
    setActiveIconIndex(index === activeIconIndex ? null : index);
  };

  const handleOpenNotification = (event: React.MouseEvent<HTMLButtonElement>) => {
    setNotificationAnchorEl(event.currentTarget);
    setOpenNotification(true);
    // Refresh notification count when opening the panel
    fetchNotificationCount();
  };
  const handleCloseNotification = () => {
    setNotificationAnchorEl(null);
    setOpenNotification(false);
    // Refresh notification count when closing the panel in case notifications were read
    fetchNotificationCount();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');
  const is1980 = useMediaQuery('(max-width:1280px)');

  const [studentInfo, setStudentInfo] = useState({
    fullName: "",
    Profile: ""
  });

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Get user type from localStorage
  const userDetailsFromStorage = getUserDetails();
  const userType = userDetailsFromStorage?.Type || '';
  useEffect(() => {
    const userDetails = getUserDetails();
    if (userDetails?.ContactId) {
      getStudentInfo(userDetails.ContactId)
        .then((data) => {
          setStudentInfo({
            fullName: `${data?.firstName} ${data?.lastName}`,
            Profile: data?.profile
          });
        })
        .catch(() => setError("Failed to load student details."))
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    if (userDetails?.ContactId) {
      fetchNotificationCount();
      const interval = setInterval(fetchNotificationCount, 30000);
      return () => clearInterval(interval);
    }
  }, [userDetails, fetchNotificationCount]);

  if (loading) return <KenLoader />;
  if (error) return <Typography color="error">{error}</Typography>;
  const handleListClick = (path: string, index: number) => {
    console.log("path", path);
    navigate(path);

    if (path === "/login") {
      // Calculate session duration
      const sessionEndTime = new Date().getTime();
      const sessionStartTime = localStorage.getItem("sessionStartTime");

      let timeSpent = "0 min 0 sec";

      if (sessionStartTime) {
        let durationMs = sessionEndTime - parseInt(sessionStartTime);

        let hours = Math.floor(durationMs / (1000 * 60 * 60));
        let minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((durationMs % (1000 * 60)) / 1000);


        if (hours > 0) {
          timeSpent = `${hours} hr ${minutes} min ${seconds} sec`;
        } else {
          timeSpent = `${minutes} min ${seconds} sec`;
        }

        console.log(`Duration: ${timeSpent}`);
      }

      mixpanel.track("User Logged Out", {
        time: new Date().toISOString(),
        timeSpent: timeSpent,
      });

      mixpanel.reset();
      dispatch({ type: "LOGOUT" });
    }
  };




  // useEffect(() => {
  //   getBasicProfileSetting(userData?.applicantId)
  //     .then((res) => {
  //       console.log('353454353', res);
  //       setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }, []);
  console.log('innerwidth12', window.innerWidth);

  return (
    <>
      {isMobile ? (
        <Grid container spacing={2} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={12} sm={12}>
            <Paper sx={{ mt: 2, ml: 2, mb: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={2} xs={12} lg={12}>
                <Grid item xs={2}>
                  <div>
                    <Button id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                      <img
                        className={classes.profilImageMobileView}
                        src={userData?.applicationProfile ? userData.applicationProfile : Image.Images.DefaultProfileImage}
                        alt="profile"
                        style={{ width: '40px', height: '40px', cursor: 'pointer' }}
                      // onClick={() => navigate(routes.settings)}
                      />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MobileNavTabs handleListClick={handleListClick} name="mobile" handleClose={handleClose} />
                    </Menu>
                  </div>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <AppBreadCrumbs />
                </Grid>
                <Grid item xs={5.5} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', mt: 0.5, gap: 1 }}>
                  {/* Mobile notification and calendar icons */}
                  <Tooltip title="My Schedule" placement="top" arrow>
                    <IconButton
                      size="small"
                      sx={{
                        backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 0 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(0);
                        navigate(routes.mySchedule);
                      }}
                    >
                      <img src={CalendarIcon} style={{ width: '24px', height: '24px' }} />
                    </IconButton>
                  </Tooltip>

                  {userType === 'Student' && (
                    <Tooltip title="Settings" placement="top" arrow>
                      <IconButton
                        size="small"
                        sx={{
                          backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                          color: activeIconIndex === 2 ? '#5981FF' : 'black',
                          '&:hover': {
                            backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                          },
                        }}
                        onClick={() => {
                          handleClickIcon(2);
                          navigate(routes.studentSettings);
                        }}
                      >
                        <img src={SettingIcon} style={{ width: '24px', height: '24px' }} />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title="Notifications" placement="top" arrow>
                    <IconButton
                      size="small"
                      sx={{
                        backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 1 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={(event) => {
                        handleClickIcon(1);
                        handleOpenNotification(event);
                      }}
                    >
                      <Badge badgeContent={notificationCount} color="primary">
                        <img src={NotificationIcon} style={{ width: '24px', height: '24px' }} />
                      </Badge>
                    </IconButton>
                  </Tooltip>

                  <img alt="logo" className={classes.actionLogo} src={Image.Images.DefaultOrganizationLogo} />
                  <div style={{ textAlign: 'start', marginTop: 5 }}>
                    <Typography className={classes.actionText}>Ken42</Typography>
                    <Typography className={classes.actionText}>Alumni Suite</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
            <Popover
              open={openNotification}
              anchorEl={notificationAnchorEl}
              onClose={handleCloseNotification}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              disableRestoreFocus
            >
              <NotificationModal handleClose={handleCloseNotification} refreshNotificationCount={fetchNotificationCount} />
            </Popover>
            <Box
              sx={{
                overflow: 'auto',
                // overflow: isMobile ? 'auto' : 'hidden',
                // height: '100vh',
                // width: '100vw',
                height: '100vh',
                width: '100vw',
                scrollbarColor: 'white',
                p: 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3} style={{ padding: isMobile ? '4px 4px' : '20px 0px 20px 20px' }} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={2} md={2}>
            <Paper className={classes.nav}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px', marginTop: '32px' }}>
                <img
  className={classes.profilImage}
  src={
    userType === 'Student'
      ?  DefaultStudentImage
      :  DefaultFacultyImage
  }
  alt="profile"
  style={{
    display: 'inline-block',
    padding: '4px',
    borderRadius: '50%',
    background: 'linear-gradient(90deg, #3061FF -15.54%, #30C1FF 133.56%)',
  }}
  onClick={() => navigate(routes.myProfile)}
/>
                  <Typography className={classes.profileName}>
                    {userData.name || ''}
                  </Typography>
                  <center>
                    <Typography style={{ fontSize: '12px', color: '#373A45', border: '1px solid #3061FF', padding: '5px 12px', borderRadius: '30px', width: 'fit-content', fontWeight: '400' }}>
                      Role : {userData.Type || ''}
                    </Typography>
                  </center>
                </div>
                <div>
                  <SideNavTabs handleListClick={handleListClick} />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10} md={10}>
            <Grid container spacing={3}>
              <Grid item container spacing={3} xs={12} lg={12}>
                <Grid item xs={6} sm={8} md={8.5} lg={8.5}>
                  <Paper className={classes.header} sx={{ borderRadius: '9px !important' }}>
                    <AppBreadCrumbs />
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3.5} lg={3.5}>
                  <Paper className={classes.actions} sx={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
                      <Tooltip title="My Schedule" placement="top" arrow>
                        <IconButton
                          sx={{
                            marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '2px' },
                            backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                            color: activeIconIndex === 0 ? '#5981FF' : 'black',
                            '&:hover': {
                              backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                            },
                          }}
                          onClick={() => {
                            handleClickIcon(0);
                            navigate(routes.mySchedule);
                          }}
                        >
                          <img src={CalendarIcon} style={{ width: '30px', height: '30px' }} />
                        </IconButton>
                      </Tooltip>

                      {userType === 'Student' && (
                        <Tooltip title="Settings" placement="top" arrow>
                          <IconButton
                            sx={{
                              marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '2px' },
                              backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                              color: activeIconIndex === 2 ? '#5981FF' : 'black',
                              '&:hover': {
                                backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                              },
                            }}
                            onClick={() => {
                              handleClickIcon(2);
                              navigate(routes.studentSettings);
                            }}
                          >
                            <img src={SettingIcon} style={{ width: '30px', height: '30px' }} />
                          </IconButton>
                        </Tooltip>
                      )}

                      <Tooltip title="Notifications" placement="top" arrow>
                        <IconButton
                          sx={{
                            marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '2px' },
                            backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                            color: activeIconIndex === 1 ? '#5981FF' : 'black',
                            '&:hover': {
                              backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                            },
                          }}
                          onClick={(event) => {
                            handleClickIcon(1);
                            handleOpenNotification(event);
                          }}
                        >
                          <Badge badgeContent={notificationCount} color="primary">
                            <img src={NotificationIcon} style={{ width: '30px', height: '30px' }} />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Popover
                      open={openNotification}
                      anchorEl={notificationAnchorEl}
                      onClose={handleCloseNotification}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      disableRestoreFocus
                    >
                      <NotificationModal handleClose={handleCloseNotification} refreshNotificationCount={fetchNotificationCount} />
                    </Popover>
                    <div style={{ width: '0.75px', height: '45px', background: '#C6C9D2' }} />
                    <img alt="logo" className={classes.actionLogo} src={Image.Images.headerLogo} />
                  </Paper>
                </Grid>
              </Grid>
              <Box
                sx={{
                  overflow: 'auto',
                  flexGrow: 1,
                  minHeight: 'calc(100vh - 100px)',
                  width: '100%',
                  scrollbarColor: 'white',
                  paddingTop: '3px',
                  paddingLeft: '22px',
                  scrollbarWidth: 'none',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AppLayout;
